import { gql } from '@src/lib/gql'

/** Seat payload so the compensation calculator can attach a FAST to that engagement. */
export const COMP_CALCULATOR_ENGAGEMENT = gql`
  query CompCalculatorEngagement($advisorEngagementId: String!) {
    advisorEngagement(advisorEngagementId: $advisorEngagementId) {
      id
      advisorEngagementId
      founderUserId
      advisorUserId
      advisorName
      advisorEmail
      companyId
      sourceKey
      isAI
      statusKey
      currentUserCanEdit
      category {
        id
        key
        title
      }
      company {
        id
        companyId
        name
      }
      advisorUser {
        id
        userId
        fullName
        displayName
        email
      }
      currentAgreement {
        id
        advisorAgreementId
        statusKey
        status {
          id
          key
          title
        }
      }
    }
  }
`
